import dynamic from "next/dynamic";
const App = dynamic(() => import("../../components/App"));
import Head from "next/head";
import { useRouter } from "next/router";
import { Breadcrumb, Image, Row, Col } from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Link from "next/link";

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const ComponentTh = () => {
  return (
    <div className="container" style={{ marginTop: 24 }}>
      <h3 id="cookie-policy" style={{ marginBlock: 24 }}>
        <a aria-hidden="true" href="#cookie-policy" tabindex="-1">
          <span className="icon icon-link"></span>
        </a>
        วิธีการจัดส่งสินค้า
      </h3>
      <p>
        เราจะทำการจัดส่งสินค้าหลังจากที่ได้รับและมีการตรวจสอบหลักฐานการชำระเงินเรียบร้อยแล้ว
      </p>

      <h4>จัดส่งโดยบริษัทขนส่งสินค้า</h4>
      <Image
        style={{ width: 200 }}
        src="/static/images/howto/kerry.png"
        preview={false}
        alt="howto"
      />

      <h4>โดยมีระยะเวลาจัดส่งสินค้า ดังนี้</h4>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-dark">
            <tr>
              <th scope="col" width="25%">
                พื้นที่จัดส่ง
              </th>
              <th scope="col" width="75%">
                ระยะเวลา
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>กรุงเทพฯ และปริมณฑล</td>
              <td>1-3 วันทำการ</td>
            </tr>
            <tr>
              <td>จังหวัดอื่นๆ</td>
              <td>3-7 วันทำการ</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <p>
        ทั้งนี้ ท่านสามารถตรวจสอบสถานะสินค้าระหว่างการจัดส่ง
        ได้ตามรายละเอียดด้านล่างนี้
      </p>
      <h4>Kerry :</h4>
      <p>ตรวจสอบได้ที่ https://th.kerryexpress.com/th/track/</p>
      <br />
      <p>
        โปรดทราบว่า ระยะเวลาในการจัดส่งสินค้าอาจมีการคลาดเคลื่อนได้
        ขึ้นอยู่กับระยะทาง ทั้งนี้ ในช่วงเทศกาล
        วันหยุดนักขัตฤกษ์และวันหยุดต่อเนื่อง อาจใช้ระยะเวลานานเป็นพิเศษ
      </p>
    </div>
  );
};

const ComponentEn = () => {
  return (
    <div className="container" style={{ marginTop: 24 }}>
      <h3 id="cookie-policy" style={{ marginBlock: 24 }}>
        <a aria-hidden="true" href="#cookie-policy" tabindex="-1">
          <span className="icon icon-link"></span>
        </a>
        About Shipment
      </h3>
      <p>
        We will deliver the product after payment has been received and proof of
        payment has been verified.
      </p>

      <h4>The shipping company</h4>
      <Image
        style={{ width: 200 }}
        src="/static/images/howto/kerry.png"
        preview={false}
        alt="howto"
      />

      <h4>Delivery time as mentioned in table below</h4>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-dark">
            <tr>
              <th scope="col" width="25%">
                Delivery Coverage
              </th>
              <th scope="col" width="75%">
                Estimate delivery time
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Bangkok & Greater Bangkok</td>
              <td>1-3 working days</td>
            </tr>
            <tr>
              <td>Other provinces</td>
              <td>3-7 working days</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <p>You can track your shipping status through link below</p>
      <h4>KERRY :</h4>
      <p>Tracking link : https://th.kerryexpress.com/th/track/</p>
      <br />
      <p>
        Please note that delivery times may vary. Depending on the distance,
        during festivals, public holidays and continuous holidays which may take
        a longer delivery time.
      </p>
    </div>
  );
};

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const router = useRouter();
  const { locale } = router;
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const { t } = useTranslation("common");

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Shopping and Delivery</title>
      </Head>
      <Row justify="center" style={{ marginBlock: 24 }}>
        <Col xs={22} sm={22} md={22} lg={22} xl={20}>
          <Breadcrumb
            items={[
              {
                key: "home",
                title: (
                  <Link href={`/${queryParam ? `?${queryParam}` : ``}`}>
                    {t("home")}
                  </Link>
                ),
              },
              {
                key: "terms-service-shipping",
                title: `${t("terms-service-shipping")}`,
              },
            ]}
          />
          {locale == "th" ? <ComponentTh /> : <ComponentEn />}
        </Col>
      </Row>
    </App>
  );
};

export default Home;
